<coa-dashboard-content
  [categoryId]="categoryId"
  [clientId]="clientId"
  [dateRange]="dateRange">
</coa-dashboard-content>
